const React = require('react');

const Content = require('../common/Content.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Name(props) {
    const artist = props.itemData || {};
    let name = artist.Name || '';
    let blockProps = {};
    let includes = {};
    if (props.config && props.config.Config) {
        if (props.config.Config.Block) {
            blockProps = props.config.Config.Block;
        }
        if (props.config.Config.Includes) {
            includes = props.config.Config.Includes;
        }
    }
    let date = '';
    if (includes.Birthdate && !Utilities.isNullOrWhitespace(artist.Birthdate)) {
        if (!Utilities.isNullOrWhitespace(blockProps.textLabelBirthdate)) {
            date += blockProps.textLabelBirthdate;
        }
        date += artist.Birthdate;
    }
    if (includes.Deathdate && !Utilities.isNullOrWhitespace(artist.Deathdate)) {
        if (!Utilities.isNullOrWhitespace(date) && !Utilities.isNullOrWhitespace(blockProps.textLabelSeparator)) {
            date += blockProps.textLabelSeparator;
        }
        if (!Utilities.isNullOrWhitespace(blockProps.textLabelDeathdate)) {
            date += blockProps.textLabelDeathdate;
        }
        date += artist.Deathdate;
    }
    let dateProps;
    if (!Utilities.isNullOrWhitespace(date)) {
        dateProps = Utilities.Config.getStyle(props.data, blockProps, 'Date', { display: 'inline-block', whiteSpace: 'pre-wrap' });

        if (blockProps.wrapDate == true) {
            date = `(${date})`;
        }
        if (!Utilities.isNullOrWhitespace(name)) {
            date = ` ${date}`;
        }
        date = <span style={dateProps}>{date}</span>;
    } else if (!props.builder && Utilities.isNullOrWhitespace(name)) {
        return null;
    }
    const content = [];
    if (!Utilities.isNullOrWhitespace(name)) {
        content.push(<React.Fragment key="name">{name}</React.Fragment>)
    }
    if (date) {
        content.push(<React.Fragment key="date">{date}</React.Fragment>);
    }
    return <Content.Value {...props} value={content} />;
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    { display: 'Name Properties', id: 'nameProps', type: 'header' },
                    ..._TypeConfig.options.text({}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Lifetime Properties', id: 'dateProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Date' }, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    {
                        display: 'Birthdate Prefix',
                        name: 'textLabelBirthdate',
                        type: 'text',
                        value: 'b. '
                    },
                    {
                        display: 'Date Separator',
                        name: 'textLabelSeparator',
                        type: 'text',
                        value: ' - '
                    },
                    {
                        display: 'Deathdate Prefix',
                        name: 'textLabelDeathdate',
                        type: 'text',
                        value: 'd. '
                    },
                    {
                        display: 'Wrap In Parentheses',
                        name: 'wrapDate',
                        type: 'checkbox',
                        value: true
                    }
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Birthdate', name: 'Birthdate', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Deathdate', name: 'Deathdate', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, {}); }
    }
};

module.exports = {
    Component: Name,
    TypeConfig
};